import React, { createContext, useContext, useRef, useEffect } from 'react';
import { useRouter } from 'next/router';

interface HeadingContextProps {
  headingRef: React.MutableRefObject<HTMLElement | null>;
  isPLPref: React.MutableRefObject<boolean>;
}

const HeadingContext = createContext<HeadingContextProps>({
  headingRef: { current: null },
  isPLPref: { current: false },
});

export const useHeading = (): HeadingContextProps => useContext(HeadingContext);

export const HeadingProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const headingRef = useRef<HTMLElement | null>(null);
  const isPLPref = useRef<boolean>(false);
  const router = useRouter();

  useEffect(() => {
    return () => {
      headingRef.current = null;
    };
  }, [router.asPath]);

  return (
    <HeadingContext.Provider value={{ headingRef, isPLPref }}>
      {children}
    </HeadingContext.Provider>
  );
};
